import { useMemo } from "react";
import { Route } from "types/Routes";
import { Helmet } from "react-helmet";

type HeadEnhanceRouteProps = {
  route: Route;
  children: React.ReactNode;
};

export const HeadEnhanceRoute: React.FC<HeadEnhanceRouteProps> = ({ route, children }) => {
  const head = useMemo(() => {
    if (route.head) {
      return (
        <Helmet>
          <title>{route.head.title}</title>
        </Helmet>
      );
    }

    return (
      <Helmet>
        <title>{route.name}</title>
      </Helmet>
    );
  }, [route.head]);

  return (
    <>
      {head}
      {children}
    </>
  );
};
